import ScrollSpy from './ScrollSpy';
import ScrollSpyItem from './ScrollSpyItem';

export default ScrollSpy;

export {
  ScrollSpyItem,
};
